import axios from "axios";

export const state = {
    examsets: [],
};

export const getters = {
    examsets: state => state.examsets,
};

export const mutations = {
    setExam(state, newValue) {
        state.examsets = newValue
    },
};

export const actions = {
    fetchExamSets({ commit }) {
        axios.get('/examsets').then(res => {
            commit('setExam', res.data.examsets);
        })
    },
};
